<!--编写要点 -->
<!--1.tab键留空-->
<template>
	<div style="width:100%;height:100%">
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" :disabled="download" size="mini" @click="exps">{{$t('getapi[6111]')}}</el-button>

					<el-upload
							class="upload-demo"
							ref="upload"
							:action="uploadurl"
							:on-remove="handleRemove"
							:on-change="handleChange"
							:on-success="handleSuccess"
							:on-error="handleError"
							:file-list="fileList"
							:limit="1"
							style="margin-left: 8px"
					>
						<el-button slot="trigger" size="mini" type="primary">上传数据</el-button>
					</el-upload>
				</div>
				<div style="width: 50%;text-align: right">
					<!-- <h5>{{ iTemplate }}</h5> -->
					<el-button type="primary" size="mini" :disabled='!btnexport' @click="Verify">校验数据</el-button>
					<!-- <el-button type="primary" size="mini" :disabled='!btnsave' @click="save">导入数据</el-button> -->
					<el-button type="primary" :disabled="!downloadfile" size="mini" @click="expserror">{{$t('getapi[12668]')}}</el-button>
					<el-button type="primary" size="mini" @click="next" :disabled="!errorflag">下一处错误</el-button>
					<el-button type="primary" size="mini" @click="previous" :disabled="!errorflag">上一处错误</el-button>
				</div>

			</div>
		</el-card>


		<!-- <div class="btngroup">
            <el-button icon="el-icon-document"  @click="exps" type="warning">下载模板</el-button>
            <el-upload class="upload-demo"
            :action="uploadurl"
            :on-change="handleChange"
            :on-success="handleSuccess"
            :on-error="handleError"
            :file-list="fileList">
            <el-button type="primary" @click="upload">上传数据<i class="el-icon-upload el-icon--right"></i></el-button>
            </el-upload>
            <el-button icon="el-icon-position"  @click="save" type="success">校验保存</el-button>

        </div> -->


		<!-- <u-table
        :data="tableData"
        use-virtual
        showHeaderOverflow="title"
        :height="60"
        :row-height="50"
        :header-cell-class-name="tableHeadCellClassName"
        border
        style="width: 100%; margin-top: 20px"
        >
        <u-table-column   v-for="item in returnArray"
            :key="item.Headen"
            :prop="item.Headen"
            :label="item.Headcn"
        >
        </u-table-column>
        </u-table> -->
		<div style="padding: 3px">
			<span>{{title}}</span>
		</div>
		<vxe-table :data="tableData" size="mini" :loading="loading"
				   :header-cell-class-name="tableHeadCellClassName"
				   :height="tableHeight - 30"
				   :auto-resize="true"
				   :row-class-name="tableRowClassName"
				   stripe
				   border
				   resizable
				   :highlight-current-row="true"
				   ref="singleTable"
				   @cell-click="selectrow"
				   show-overflow="tooltip">
			<vxe-table-column show-footer-overflow v-for="item in returnArray"
							  :key="item.Headen"
							  :field="item.Headen"
							  :title="item.Headcn"
							  width="120px"
			>
			</vxe-table-column>
		</vxe-table>

	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'ppbatchoverimp',
        data() {
            return {
                tableHeight: window.innerHeight - 160, // 主表高度
                btnexport: false,
                btnsave: false,
                returnArray: [],
                fileList: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                userData: [], // 用户信息
                tableData: [],// 主表数据
                returnURL: '',
                iTemplate: 20,//模板编号
                title: '', //标题
                errorindex: -1,
                errorflag: false,
                download:false,
                fileURL:'',
                downloadfile:false,
            };
        },
        mounted: function () {
            let that = this;
            //初始化数据
            that.fileList = [];
            that.clear();
            //设置数据
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.download=false;
            this.title = '批量修改采购单价'
            console.log(">>>>>>>>传入模板id>>>>>>>>>>");
            console.log(this.$route);//2 .物料主文件导入  20，采购价格
            that.iTemplate = 20;
            that.uploadurl = Common.Url + 'Basic/ImpExp/ImportFile?iTemplate=' + that.iTemplate + '&MultyVer=0&token=' + token;
            console.log(that.uploadurl);
        },
        created: function () {
            this.clear();
        },
        methods: {
            clear() {
                let that = this;
                that.returnArray = [];
                that.fileList = [];
                that.tableData = [];
                that.returnURL = '';
            },
            tableRowClassName({ row, rowIndex,$rowIndex }) {
                row.index = $rowIndex;
            },
            exps() {
                let that = this;
                let token = JSON.parse(that.userData).token;
                let lang = 0
                let language = window.localStorage.getItem('lang')
                if(language == 'zh'){
                    lang = 0
                } else if(language == "en"){
                    lang = 1
                }
                let data = {
                    "MultyVer": lang,
                    "iTemplate": that.iTemplate,
                    "FilePath": "",
                    "LangType": lang

                };
                $.ajax({
                    url: Common.Url + 'Basic/ImpExp/ExportTemplate?token=' + token,
                    type: 'post',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);

                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
            },
            expserror(){
                let that = this;
                let hrefurl = Common.Url + that.fileURL;
                window.open(hrefurl);
            },
            handleChange(file, fileList) {
                //this.fileList = fileList.slice(-3);
                console.log("--------changefile-------");


            },
            //上传成功回调
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                if (res.Success == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    return;
                }
                for (let i = 0; i < res.DataContent.TbHeader.length; i++) {
                    res.DataContent.TbHeader[i].Headen = res.DataContent.TbHeader[i].Headen.toUpperCase();
                }
                that.btnexport=true;
                that.downloadfile=false;
                that.errorflag=false;
                that.btnsave=false;
                that.returnArray = res.DataContent.TbHeader;
                that.tableData = res.DataContent.dt;
                that.returnURL = res.DataContent.URL;
                that.fileList = [];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err)//上传失败
            },
            handleRemove(file, fileList) {
                console.log("--------handleRemove-------");
                this.clear();
            },
            tableHeadCellClassName({row, column, rowIndex, columnIndex}) {

                console.log("--------表头样式tableHeadCellClassName-------");
                let that = this;
                if (that.returnArray[columnIndex].IsNotNull) {
                    console.log("--------置红-------Index=" + columnIndex);
                    return 'warning-cell';
                }
                return '';
            },
            //校验并保存
            Verify() {
                let that = this;
                that.loading = true;
                let token = JSON.parse(that.userData).token;
                let lang = 0
                let language = window.localStorage.getItem('lang')
                if(language == 'zh'){
                    lang = 0
                } else if(language == "en"){
                    lang = 1
                }
                let data = {
                    "MultyVer": 0,
                    "iTemplate": that.iTemplate,
                    "FilePath": that.returnURL,
                    "LangType": lang
                };
                let posturl = Common.Url + '/Basic/ImpExp/VerifyFile?token=' + token;
                //console.log("校验保存地址："+posturl);
                //console.log(JSON.stringify(data));
                that.btnexport = true;
                $.ajax({
                    url: posturl,
                    type: 'post',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (res) {
                        that.loading = false;
                        that.btnexport = false;
                        if (res.Success == 1) {
                            that.btnsave=true;
                            that.tableData = res.DataContent.dt
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        } else {
                            that.btnsave=false;
                            that.tableData = [];
                            that.fileURL=res.DataContent.fileURL;
                            if(!that.$limits.fnIsEmpty(that.fileURL)){
                                that.downloadfile=true;
                            }
                            console.log(res);
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                            //头上加一列错误信息
                            var addColumn = {
                                Headen: 'Msg',
                                Headcn: '状态',
                                IsNotNull: true
                            }
                            if (that.returnArray[0].Headen != 'Msg') {
                                that.returnArray.unshift(addColumn);
                            }
                            that.tableData = res.DataContent.dt;
                            that.errorflag = true
                            that.errorindex = -1
                        }
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });


            },
            //保存数据
            save() {
                let that = this;
                that.loading = true;
                let token = JSON.parse(that.userData).token;
                let lang = 0
                let language = window.localStorage.getItem('lang')
                if(language == 'zh'){
                    lang = 0
                } else if(language == "en"){
                    lang = 1
                }
                let data = {
                    "MultyVer": 0,
                    "iTemplate": that.iTemplate,
                    "FilePath": that.returnURL,
                    "LangType": lang,
                    "DataSource":that.tableData
                };
                let posturl = Common.Url + '/Basic/ImpExp/ImportDataByFile?token=' + token;
                $.ajax({
                    url: posturl,
                    type: 'post',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (res) {
                        that.loading = false;
                        that.btnexport = false;
                        if (res.Success == 1) {
                            that.btnsave=false;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        } else {
                            that.btnexport = false;
                            that.btnsave=false;
                            that.tableData = [];
                            that.fileURL=res.DataContent.fileURL;
                            if(!that.$limits.fnIsEmpty(that.fileURL)){
                                that.downloadfile=true;
                            }
                            console.log(res);
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                            //头上加一列错误信息
                            var addColumn = {
                                Headen: 'Msg',
                                Headcn: '状态',
                                IsNotNull: true
                            }
                            if (that.returnArray[0].Headen != 'Msg') {
                                that.returnArray.unshift(addColumn);
                            }
                            that.tableData = res.DataContent.dt;
                            that.errorflag = true
                            that.errorindex = -1
                        }
                    },
                    error: function (xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });


            },
            selectrow({row}) {
                let that = this
                that.errorindex = this.$refs.singleTable.getRowIndex(row)
            },
            // 下一处错误
            next(){
                let that = this
                let row = null
                if(that.errorindex == -1){
                    for(let i = 0;i<that.tableData.length;i++){
                        if(that.tableData[i].Msg != null){
                            row = that.tableData[i]
                            that.errorindex = this.$refs.singleTable.getRowIndex(row)
                            break
                        }
                    }
                } else {
                    for(let i = (that.errorindex + 1);i<that.tableData.length;i++){
                        if(that.tableData[i].Msg != null){
                            row = that.tableData[i]
                            that.errorindex = this.$refs.singleTable.getRowIndex(row)
                            break
                        }
                    }
                }
                that.$refs.singleTable.setCurrentRow(row);
                setTimeout(() => {
                    this.$refs.singleTable.scrollToRow(row)
                }, 200);
            },
            previous(){
                let that = this
                let row = null
                for(let i = (that.errorindex -1);i > 0;i--){
                    if(that.tableData[i].Msg != null){
                        row = that.tableData[i]
                        that.errorindex = this.$refs.singleTable.getRowIndex(row)
                        break
                    }
                }
                that.$refs.singleTable.setCurrentRow(row);
                setTimeout(() => {
                    this.$refs.singleTable.scrollToRow(row)
                }, 200);
            }
        }
    }
</script>

<style scoped lang="less">
	input {
		width: 100%;
		height: 35px;
		border-radius: 8px;
		border: 1px solid #dcdfe6;
	}

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
		}
	}

	.alignment-left {
		text-align: left;
	}

	.alignment-right {
		text-align: right;
	}

	.upload-demo{
		display: flex;
		.el-upload-list el-upload-list--text{
			height: 18px
		}
		/deep/.el-upload-list__item{
			height: 18px;
			margin-top: -2px;
		}
	}
</style>

